import React from 'react';

class FormatoSimplificado1347543PlanGoldPlus_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347543 Plan Gold +';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347543_GOLD%2B_2024_V2.pdf?alt=media&token=02427edc-6e94-4fc4-836d-38bf8d2f974a';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347543PlanGoldPlus_pdf